<template>
  <button
    class="btn -material"
    type="button"
    :class="{
      '-open': isFlyoutOpen,
      '-complete': !isSecondary,
      '-completed': isComplete,
      '-secondary-complete': isSecondary,
      '-disabled': disabled,
    }"
    :disabled="disabled ? true : undefined"
    @click="$emit('click-action', $event)"
  >
    {{ isComplete ? completeText : incompleteText }}
    <i
      class="material-symbols-outlined fill btn-ico"
      aria-hidden="true"
      :data-icon="isComplete ? 'check_circle' : 'trip_origin'"
    ></i>
  </button>
</template>

<script>
import { defineComponent } from 'vue'
/**
 * Simple UI component to power complete buttons.
 *
 * $emits click action for parent components to handle
 * - click-action
 */
export default defineComponent({
  name: 'CompleteButton',
  components: {},
  props: {
    isComplete: {
      type: Boolean,
      required: true,
    },
    incompleteText: {
      type: String,
      default: 'Mark Complete',
    },
    completeText: {
      type: String,
      required: true,
    },
    // used with multi-complete-button
    isFlyoutOpen: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // only needed for multi-complete-button and secondary button list
    isSecondary: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click-action'],
  data() {
    return {}
  },
})
</script>
